import { useRef, useState, useEffect } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import Header from "../../Header/header";
import Footer from "../../Footer/Footer";
import HeaderMenu from "../../Header/header-menu";
import Isi from "../../ISI/Isi";
import './Homepage.css'
import IsiFrame from '../../ISI/Isi-frame';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import MainLayout from "../../Layouts/Main_Layout";
import { Helmet } from "react-helmet";
import { Carousel, Button } from "react-bootstrap";

export default function Home() {
  const myRef = useRef(null)
  const [show, setShow] = useState(true)
  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const executeScroll = () => {
    myRef.current.scrollIntoView();
    setShow(true)
  }
  const location = useLocation();

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  useEffect(() => {
    setTimeout(() => {
      if (location.hash === '#full-ISI') {
        myRef.current.scrollIntoView();
      }
    }, 1000);

    const calculateOffset = () => {
      const componentElement = myRef.current;

      if (myRef) {
        const offsetTop = componentElement.offsetTop;
        function handleScroll() {
          if (window.innerHeight + window.scrollY > offsetTop) {
            setShow(false);
          }
          else (
            setShow(true)
          )
        }

        window.addEventListener("scroll", handleScroll);


        return () => {
          window.removeEventListener("scroll", handleScroll);
        };
      }
    };
    calculateOffset();
    window.addEventListener('resize', calculateOffset);
    return () => {
      window.removeEventListener('resize', calculateOffset);
    };
  }, [location]);

  return (
    <MainLayout>
      <Helmet>
        <title>INBRIJA® (levodopa inhalation powder) for Patients</title>
        <meta property="og:description" content="Learn about INBRIJA, Patient Support Services, and downloadable resources. Watch a video about a person who uses INBRIJA. See Indication, Important Safety Information, and Patient Information Leaflet." />
        <meta property="og:url" content="https://inbrija.com" />
        <meta name="description" content="Learn about INBRIJA, Patient Support Services, and downloadable resources. Watch a video about a person who uses INBRIJA. See Indication, Important Safety Information, and Patient Information Leaflet." />
        <meta property='og:site_name' content='INBRIJA.COM' />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://inbrija.com/assets/images/Inbrija-OG-Image.jpg" />
        <meta property='og:image:alt' content='INBRIJA logo' />
        <meta property='og:title' content={`INBRIJA® (levodopa inhalation powder) for Patients`} />
      </Helmet>
      <div className="homepage">
        <Header />
        <HeaderMenu>
          <div className="container-1500">

            <Carousel activeIndex={index} onSelect={handleSelect} fade controls={false} interval={null} className="hero-section">

              <Carousel.Item className="position-relative">
                <div id="slide-muhammad-ali" className="row">
                  <div className="hero-section-image col-12 col-md-6">
                    <img src="/assets/images/2025-01-26_HomePage_Ali_Hero.png" className='img-fluid' alt={`Side profile of a woman wearing a swim cap. Her eyes are closed`} />
                    <div className="actor_portrayal">Actor portrayal.</div>
                    <div id="muhammed-ali-disclaimer" className="position-absolute">Muhammad Ali was<br className="d-md-none" /> not an INBRIJA patient.</div>
                  </div>
                  <div className="hero-section-content col-12 col-md-6 flex-column mt-5">
                    <h1 className="text-uppercase">Still <span>fighting</span> to be the greatest</h1>
                    <h4 className="mb-1 mb-md-4 w-100">Talk to your doctor to see if on-demand therapy with INBRIJA can help.</h4>
                    <div className="text-left w-100 d-none d-md-block">
                      <Link className="p-0" variant="" to="/muhammad-ali">
                        <img className='img-fluid desktop-image' alt="Get Inspired by Ali" src="/assets/images/paintbrush-ali-inspired.png" />
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="show_mobile brush-style-mob" style={{ backgroundImage: `url('/assets/images/submenu.webp')` }}>
                  <a className="talk-button-mobile" href="/muhammad-ali" id="HP_talk_doc"> Get Inspired like Ali
                    <svg style={{ marginLeft: '10px' }} width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 8.00049L17 8.00049" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M11 1.5835L17.4167 8.00016L11 14.4168" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </a>
                </div>
              </Carousel.Item>

              <Carousel.Item className="position-relative">
                <div id="fighter-support">
                  <div className='hero-section-content'>
                    <h1>Every <span><img src="/assets/images/paintbrush-fighter.png" className='img-fluid desktop-image' alt="Fighter" loading="lazy" /></span> needs<br className="d-none d-md-block" /> support in<br className='d-md-none' />  their corner</h1>
                    <h4 className="mb-1 mb-md-4">Find information that<br className="d-md-none" /> may be<br className="d-none d-md-block" /> helpful for carepartners</h4>
                    <div>
                      <Button className="p-0" variant="" onClick={() => { navigate('/carepartner-resources') }}>
                        <img className='img-fluid desktop-image' alt="Get Resources" src="/assets/images/paintbrush-resourcepartner.png" />
                      </Button>
                    </div>
                    <div className="actor-disclaimer actor_portrayal position-absolute">Actor portrayal.</div>
                  </div>
                </div>
              </Carousel.Item>

              <Carousel.Item className="position-relative">
                <div id="fight-symptoms">
                  <div className='hero-section-content'>
                    <h1>FIGHT RETURNING <br className="d-none d-lg-block " /> PARKINSON'S<br className="d-none d-md-block" /> SYMPTOMS <span>NOW</span></h1>
                    <h4><span className="fw-bold">For the Fighters&trade;</span></h4>
                    <h6>INBRIJA may start to work in as little as 10 minutes.*</h6>
                    <div className="d-md-none actor_portrayal">Actor portrayal.</div>
                    <Link to="/about-inbrija#talking-with-doctor" id="HP_talk_doc">Talk with your doctor <svg width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 8L17 8" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M11 1.58301L17.4167 7.99967L11 14.4163" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    </Link>
                  </div>
                  <div className='hero-section-image'>
                    <img src="/assets/images/INBRIJA_SWIMMER_A_FINAL 1.webp" className='img-fluid' alt={`Side profile of a woman wearing a swim cap. Her eyes are closed. The words on the side of her swim cap are "So sluggish but I'll fight it. I won't let it stop me.`} />
                    <div className="d-none d-md-block actor_portrayal">Actor portrayal.</div>
                  </div>
                </div>
                <div className="show_mobile brush-style-mob" style={{ backgroundImage: `url('/assets/images/submenu.webp')` }}>
                  <a className="talk-button-mobile" href="/about-inbrija#talking-with-doctor" id="HP_talk_doc"> Talk to your Doctor
                    <svg style={{ marginLeft: '10px' }} width="19" height="16" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M1 8.00049L17 8.00049" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M11 1.5835L17.4167 8.00016L11 14.4168" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </a>
                </div>
              </Carousel.Item>

            </Carousel>
          </div>

        </HeaderMenu>
        <div className="brush-style show_desktop">
        </div>

        <div className="rachel-section">
          <div className="container">
            <div className="rachel-intro-section pt-5 pt-md-3 pt-lg-0">
              <h2>10 minutes could make the difference between losing your moments to symptom return and fighting to get them back*</h2>
              <h5 className="mt-3 mt-lg-0 px-lg-5">*In a large clinical trial, INBRIJA started improving motor symptoms in as early as 10 minutes and significant relief in motor symptoms was seen in 30 minutes of taking INBRIJA.</h5>
            </div>
          </div>
        </div>

        <div className="safety-info-homepage container">
          <h6 className="">Selected Important Safety Information</h6>
          <h5 className="">Before using INBRIJA, tell your healthcare provider about your medical conditions, including:</h5>
          <ul>
            <li>asthma, chronic obstructive pulmonary disease (COPD), or any chronic lung disease</li>
            <li>daytime sleepiness, sleep disorders, sleepiness/drowsiness without warning, or use of medicine that increases sleepiness, including antidepressants or antipsychotics</li>
            <li>dizziness, nausea, sweating, or fainting when standing up</li>
            <li>abnormal movement (dyskinesia)</li>
            <li>mental health problems such as hallucinations or psychosis</li>
            <li>uncontrollable urges like gambling, sexual urges, spending money, or binge eating</li>
            <li>glaucoma</li>
            <li>pregnancy or plans to become pregnant. It is unknown if INBRIJA will harm an unborn baby.</li>
            <li>breastfeeding or plans to breastfeed. Levodopa can pass into breastmilk and it is unknown if it can harm the baby.</li>
          </ul>
          <h6 onClick={executeScroll} className="text-underline fw-bold">Please see below for additional Important Safety Information.</h6 >
        </div>

        <div id="ali-quote" className="gray-bar text-white text-left">
          <div className="container-1500 text-white text-left pt-5 pt-md-0 pb-5 pb-md-0 px-4 px-md-0">
            <div className="row align-items-center position-relative">
              <div className="content col-12 col-md-5 col-lg-5 offset-md-1 offset-lg-2 ps-5">
                <h3 className="big-yellow-quoted-text mb-4 fst-italic mt-md-5">You don't lose if you get<br className="d-none d-md-block" /> knocked down; you lose <br className="d-none d-md-block" />if you stay down.</h3>
                <p className="mb-5">– Muhammad Ali</p>
                <Link to="/muhammad-ali" id="btn-ali-fight-back" className="btn yellow-border-btn px-5 px-md-4">See how to fight back <span className="forward-angle ms-1"></span> </Link>
              </div>
              <div className="content-image col-md-6 col-lg-4">
              </div>
            </div>
          </div>
        </div>

        <div className="yellow-brush-border"></div>

        <div id="symptom-callout" className="gray-bar text-white text-left">
          <div className="container-1500 text-white text-left pt-5 pt-md-0 pb-5 pb-md-0 px-4 px-md-0">
            <div className="row symptom-home">
              <div className="col-md-5 col-xxl-3 offset-xxl-2 symptom-home-img show_desktop d-md-flex d-none align-items-end">
                <div className="actor_portrayal">Actor portrayal.</div>
              </div>
              <div className="col-12 col-md-7 col-lg-7 col-xl-5 offset-xl-1 content px-5 px-md-3 py-5">
                <div className="highlited-text">Are your Parkinson's Symptoms Returning?</div>
                <h3>You may find yourself avoiding going out or making plans because you’re concerned about symptom return.</h3>
                <p className="">Symptom return can take you out of the moment, disrupting your day, and may even cause you to leave activities and events early when you feel symptoms emerging. </p>
                <p className="mb-4">This can look like missing work or not going out to eat, seeing friends and family, and/or participating in your favorite activities.</p>
                <Link to="/what-are-off-periods" id="HP_what_off_per" className="btn yellow-border-btn">What Are OFF Periods? <span className="forward-angle ms-2"></span></Link>
              </div>
            </div>
          </div>
        </div>

        <div className="navigation-bar">
          <div className="row">
            <div className="col-md-6">
              <Link to="/inbrija-stories" id="btn-about-watch" className="d-flex flex-column align-items-center">
                <img src="/assets/images/play-rect.svg" className="d-block mx-auto pb-2" />
                <div className="d-inline-flex align-items-center justify-content-center">
                  Watch INBRIJA in Action
                  <span className="forward-angle ms-2"></span>
                </div>
              </Link>
            </div>
            <div className="col-md-6">
              <Link to="/pdfs/doctor-discussion-guide.pdf" target="_blank" id="btn-about-prepare" className="d-flex flex-column align-items-center">
                <img src="/assets/images/icon-circle-plus.svg" className="d-block mx-auto pb-2" alt="" /> Prepare for Discussions<br /> With Your Doctor
              </Link>
            </div>
          </div>
        </div>

        <div ref={myRef}>
          <Isi />
        </div>
        {show ? <IsiFrame onClick={executeScroll} /> : ''}
        <Footer partNum="1/2026 US-INB-2500133" />
      </div>
    </MainLayout>
  )
}